import { ContentContainer } from '@/components/ui/content-container.component';
import { Skeleton } from '@/components/ui/skeleton.component';

export function MostSearchedLoading() {
  return (
    <>
      <ContentContainer className="mt-6 hidden xl:block">
        <Skeleton className="w-[28.3rem] h-6 rounded" />

        <div className="flex items-start gap-6 mt-7">
          {Array.from({ length: 4 }).map(() => (
            <div key={crypto.randomUUID()} className="flex items-center gap-1">
              <Skeleton className="w-5 h-5 rounded" />
              <Skeleton className="w-18 h-5 rounded" />
            </div>
          ))}
        </div>

        <div className="flex gap-12 mt-5 w-full">
          <div className="flex flex-col gap-8 w-full">
            {Array.from({ length: 5 }).map(() => (
              <div key={crypto.randomUUID()} className="flex items-center gap-2">
                <Skeleton className="w-full h-5 rounded" />
                <Skeleton className="w-36 h-5 rounded" />
              </div>
            ))}
          </div>
          <div className="flex flex-col gap-8 w-full">
            {Array.from({ length: 4 }).map(() => (
              <div key={crypto.randomUUID()} className="flex items-center gap-2">
                <Skeleton className="w-full h-5 rounded" />
                <Skeleton className="w-36 h-5 rounded" />
              </div>
            ))}
            <div key={crypto.randomUUID()} className="flex items-center gap-2">
              <Skeleton className="w-5 h-5 rounded" />
              <Skeleton className="w-18 h-5 rounded" />
            </div>
          </div>
        </div>

        <div className="flex justify-center mt-14">
          <div className="flex items-center gap-2">
            <Skeleton className="w-5 h-5 rounded" />
            <Skeleton className="w-72 h-5 rounded" />
          </div>
        </div>
      </ContentContainer>

      <ContentContainer className="mt-6 block xl:hidden">
        <Skeleton className="w-full h-6 rounded" />

        <div className="flex gap-6 mt-7 -mr-6 ml-3">
          {Array.from({ length: 2 }).map(() => (
            <div key={crypto.randomUUID()} className="flex items-center gap-1 w-full">
              <Skeleton className="w-6 h-5 rounded" />
              <Skeleton className="w-full h-5 rounded" />
            </div>
          ))}
          <div key={crypto.randomUUID()} className="flex items-center gap-1">
            <Skeleton className="w-5 h-5 rounded" />
            <Skeleton className="w-12 h-5 rounded-l-sm rounded-r-none" />
          </div>
        </div>

        <div className="flex flex-col gap-8 mt-9">
          {Array.from({ length: 5 }).map(() => (
            <Skeleton key={crypto.randomUUID()} className="w-full h-5 rounded" />
          ))}
        </div>

        <div className="flex items-center gap-1 mt-8">
          <Skeleton className="w-5 h-5 rounded" />
          <Skeleton className="w-18 h-5 rounded" />
        </div>

        <div className="bg-gray-100 py-10 -mx-6 pl-6 flex gap-2 mt-4">
          <Skeleton className="w-full h-24 rounded" />
          <Skeleton className="w-4 h-24 rounded-l-sm rounded-r-none" />
        </div>
      </ContentContainer>
    </>
  );
}
